@charset "UTF-8";

/* src/app/home/trailer-request/request-trailer/request-trailer.component.scss */
.long-svg {
  background-image: url(data:image/svg+xml;base64,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);
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.break {
  margin-top: 10px;
}
.trailer-card {
  display: grid;
  width: 344px;
}
.grid-container {
  display: grid;
  grid-template-rows: auto 1fr;
}
.card {
  border-color: #979797;
  height: 68px;
  display: grid;
  grid-template-rows: 43px 14px;
  grid-row-gap: 8px;
}
p {
  line-height: 13px;
  padding-top: 3px;
}
.topcols {
  margin: 0 8px;
  display: grid;
  grid-template-columns: 110px 60px 48px 88px;
  grid-column-gap: 8px;
}
.trailer-number {
  white-space: nowrap;
}
.trailer-number .number {
  margin-right: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.trailer-number span.small {
  width: 110px;
}
.trailer-number .tractor-only {
  white-space: normal;
}
.destination-sort {
  white-space: nowrap;
}
.destination-sort span.small {
  width: 60px;
}
.trailer-number p,
.destination-sort p {
  display: flex;
  flex-flow: column;
}
.trailer-number p .number,
.trailer-number p .destination-organization-name,
.destination-sort p .number,
.destination-sort p .destination-organization-name {
  line-height: 14px;
  height: 14px;
}
.trailer-number p span.item:empty:before,
.destination-sort p span.item:empty:before {
  content: "\200b";
}
.load-info {
  top: 3px;
}
.load-info span.pieceCount {
  top: 3px;
  right: 0.5rem;
  position: absolute;
}
.percent {
  left: 6px;
  top: 3px;
  position: absolute;
}
.bottomcols {
  margin: 0 8px;
  display: grid;
  line-height: 14px;
  grid-template-columns: 110px 130px 88px;
}
.palletcount {
  align-self: flex-end;
  text-align: end;
}
.serviceLevel {
  margin-left: 8px;
}
.unplanned,
.bobtail {
  border-color: #F88C00 !important;
}
.direction {
  display: flex;
  gap: 10px;
}
.length,
.due-date {
  color: #6E6E6E;
  font-size: 10px;
  line-height: 10px;
}
@media (min-width: 1280px) {
  .grid-container {
    grid-template-columns: 95px 344px;
    grid-column-gap: 8px;
  }
  .direction {
    display: block;
  }
  .trailer-card {
    width: auto;
    max-width: none;
  }
}
@media (min-width: 1880px) {
  .topcols {
    grid-template-columns: 110px 60px 48px 88px;
  }
}
/*# sourceMappingURL=request-trailer.component.css.map */
